import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: 'https://transportapi.nettaa.in',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token to requests and handle FormData
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // If data is FormData, remove Content-Type to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle global errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - Clear token and redirect to login
    // BUT: Don't redirect if we're on signup page (public endpoint)
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('customerAuthenticated');
      localStorage.removeItem('agencyAuthenticated');
      // Don't redirect if on signup page (public endpoint, 401 is expected)
      if (window.location.pathname !== '/login' && window.location.pathname !== '/signup') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

